import { DOCUMENT } from '@angular/common';
import { environment } from '@apps/clos-sessions/environments';
import { inject, Injectable, OnDestroy } from '@angular/core';
import { IS_BROWSER } from '@libs/is-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BrowserWarningModalService } from '@apps/clos-sessions/services/browser-warning-modal';

const HAS_CHECKED_BROWSER_COMPATIBILITY_LS_KEY = 'looked-info';

@Injectable({
  providedIn: 'root',
})
export class BrowserWarningEffect implements OnDestroy {
  protected isBrowser = inject(IS_BROWSER);

  protected document = inject(DOCUMENT);

  protected browserWarningModal = inject(BrowserWarningModalService);

  protected destroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  use(): void {
    if (!this.isBrowser) {
      return;
    }

    // The invite host supports installation and sign-in, not the shooting session.
    if (this.document.location?.origin === environment.firstPartyInviteOrigin) {
      return;
    }

    const isChrome = this.checkIsChrome();
    if (isChrome) {
      return;
    }

    const hasWarningShown = !!localStorage.getItem(HAS_CHECKED_BROWSER_COMPATIBILITY_LS_KEY);
    if (hasWarningShown) {
      return;
    }

    localStorage.setItem(HAS_CHECKED_BROWSER_COMPATIBILITY_LS_KEY, 'true');

    this.browserWarningModal.open().pipe(takeUntil(this.destroy$)).subscribe();
  }

  protected checkIsChrome(): boolean {
    return navigator.userAgent.includes('Chrome');
  }
}
